import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var Lazy = /*#__PURE__*/function () {
  function Lazy(executor) {
    _classCallCheck(this, Lazy);

    this.executor = executor;
    this._didRun = false;
  }
  /**
   * Get the wrapped value.
   *
   * This will force evaluation of the lazy value if it has not been resolved yet. Lazy values are only
   * resolved once. `getValue` will re-throw exceptions that are hit while resolving the value
   */


  _createClass(Lazy, [{
    key: "getValue",
    value: function getValue() {
      if (!this._didRun) {
        try {
          this._value = this.executor();
        } catch (err) {
          this._error = err;
        } finally {
          this._didRun = true;
        }
      }

      if (this._error) {
        throw this._error;
      }

      return this._value;
    }
    /**
     * Get the wrapped value without forcing evaluation.
     */

  }, {
    key: "rawValue",
    get: function get() {
      return this._value;
    }
  }]);

  return Lazy;
}();